import React, { useEffect, useRef } from 'react';

const Features = () => {
  const features = [
    {
      title: "Asset-Level Tracking",
      description: "Follow every IT asset from receipt to final disposition with our system that eliminates security gaps in your asset lifecycle process."
    },
    {
      title: "Secure Data Destruction",
      description: "Access real-time data on data destruction status, compliance certificates, and environmental impact through our certified processes."
    },
    {
      title: "Regulatory Compliance",
      description: "Our certified team handles all documentation and regulatory requirements for NIST 800-88, HIPAA, GDPR, and environmental standards."
    },
    {
      title: "Custom ITAD Programs",
      description: "We design custom workflows that match your specific IT asset mix and security requirements, not generic one-size-fits-all solutions."
    },
    {
      title: "Single Point of Contact",
      description: "Eliminate the complexity of managing multiple vendors with our end-to-end approach to IT asset disposition and data security."
    },
    {
      title: "Recovery Analytics",
      description: "Transform operational data into strategic insights with detailed reporting on asset recovery trends, market values, and optimization opportunities."
    }
  ];

  // Removed scalability and contact-strip content per homepage cleanup

  const gridRef = useRef(null);

  useEffect(() => {
    const gridEl = gridRef.current;
    if (!gridEl) return;
    const cards = gridEl.querySelectorAll('.feature-card');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );
    cards.forEach((c) => observer.observe(c));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="features">
      <div className="features-intro">
        <h2>A Complete IT Asset Disposition Solution</h2>
        <p>
          We've built infrastructure, technology, and expertise that transforms IT asset disposition from a security risk into a value generator.
        </p>
      </div>
      
      <div ref={gridRef} className="features-grid">
        {features.map((feature, index) => (
          <div
            key={index}
            className="feature-card"
            style={{ '--i': index }}
            onMouseMove={(e) => {
              const el = e.currentTarget;
              const rect = el.getBoundingClientRect();
              const x = e.clientX - rect.left;
              const y = e.clientY - rect.top;
              el.style.setProperty('--mx', `${x}px`);
              el.style.setProperty('--my', `${y}px`);
            }}
            onMouseEnter={(e) => e.currentTarget.style.setProperty('--glow', '1')}
            onMouseLeave={(e) => e.currentTarget.style.setProperty('--glow', '0')}
          >
            <div className="feature-icon" aria-hidden>⬤</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      
      {/* Scalability and contact strips removed */}
    </section>
  );
};

export default Features;
